import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../core/redux/IAppState";
import { getResource } from "../resources/getResource";
import { ApiError } from "../../core/redux/api/apiError";

export function useApiErrorSnackbar(
  errors: Array<{
    error: ApiError | undefined;
    clear: (e: ApiError) => void;
    resourceKey: string;
  }>,
  showError: (msg: string) => void,
  dedupeMs = 1500
) {
  const resources = useSelector((s: IAppState) => s.locale);
  const lastShown = useRef<{ key: string; at: number } | null>(null);

  useEffect(() => {
    // Find first error with a defined error object
    const first = errors.find(e => e.error !== undefined);
    if (!first || !first.error) return;

    const now = Date.now();
    const id = first.resourceKey;
    const error = first.error;

    // De‑dupe recently shown errors
    if (
      lastShown.current &&
      lastShown.current.key === id &&
      now - lastShown.current.at < dedupeMs
    ) {
      first.clear(error);
      return;
    }

    // Clear and show
    first.clear(error);
    showError(getResource(resources, id));

    lastShown.current = { key: id, at: now };
  }, [errors, resources, showError, dedupeMs]);
}
